import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { analytics } from '@app/events/segment/analytics';

export type OpportunityLabel = 'career-support' | 'skill-builder' | 'skill-development' | 'academic-support';
export type AudienceType = '1st-year' | '2nd-year' | '3rd-year' | '4th-year' | 'graduate' | 'all';
export type DeliveryMode = 'in-person' | 'online' | 'hybrid';
export type SkillType = 'durable' | 'technical' | 'both';
export type OpportunityStatus = 'active' | 'archived' | 'draft';

export interface OpportunityCardData {
  // Display fields
  label: string;
  labelType: OpportunityLabel;
  title: string;
  description: string;
  source: string;

  // Metadata fields
  id: string;
  campus?: string;
  careerArea?: string[];
  audienceType?: AudienceType[];
  timing?: string;
  deliveryMode?: DeliveryMode;
  skillTags?: string[];
  skillType?: SkillType;
  priorityLevel?: number;
  owner?: string;
  lastUpdated?: Date | string;
  status: OpportunityStatus;
  link?: string;
}

@Component({
  selector: 'app-opportunity-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './opportunity-card.component.html',
  styleUrl: './opportunity-card.component.css'
})
export class OpportunityCardComponent {
  @Input() opportunity!: OpportunityCardData;

  onCardClick() {
    analytics.track('Plan Action View', {
      section: 'plan',
      action: this.opportunity.title,
      action_type: this.opportunity.labelType
    });
  }
}
